// extracted by mini-css-extract-plugin
export default {"purple":"#8d53ff","pink":"#ca6be6","dark":"#1f1f1f","white":"#f8f8f8","red":"#ff6057","yellow":"#ffbd2e","green":"#27c93f","lightgray":"#c9c9c9","shadowed":"App_shadowed__BC3oN"};